import React from 'react';
import PropTypes from 'prop-types';
import css from './MultipleChoiceField.scss'
import Icon from 'SF/MaterialIcon';
import RadioButton from './RadioButton';


// This is an updated version of MultipleChoiceField that provides the end user's
// answer in the value field as a simple string instead of a complex object.
export default class RadioSelectField extends React.Component {

    changeHandler = (e, index) => {
        if (this.props.options[index].value !== e.target.value) return;
        this.props.setValue(e.target.value)
    }

    isRadioButtonSelected = (value) => {
        if(!this.props.value) return false;
        return (this.props.value === value)
    }

    render() {
        const { options, isReadOnly, hasError, questionNumber, questionText } = this.props
        return (
            <>
                <div className={css['multiple-choice-wrapper']} role="radiogroup" aria-label={questionText}>
                    {options.map((option, index) =>
                        <RadioButton
                            key={index}
                            value={option.value}
                            label={option.display}
                            checked={this.isRadioButtonSelected(option.value)}
                            onChange={(e) => this.changeHandler(e, index)}
                            disabled={isReadOnly}
                            name={`multipleChoice_${questionNumber}`}
                        />
                    )}
                </div>
                {hasError && !isReadOnly && (
                    <div className={css['input-error-message-block']} role="alert">
                        <Icon icon="error" /><p>Invalid option selected</p>
                    </div>
                )}
            </>
        )
    }
}

RadioSelectField.propTypes = {
    value: PropTypes.string,
    options: PropTypes.array,
    isRequired: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    hasError: PropTypes.bool,
    setValue: PropTypes.func,
    questionNumber: PropTypes.number,
    questionText: PropTypes.string
}
